import React from 'react'
import classNames from 'classnames'

import { Icon, TimedDisplay } from '@scentregroup/ui'

import Spinner from '../spinner'
import { useEvolvedContext } from '../../context'
import style from './index.module.scss'
import { RenderedSectionResults } from './types'

const SPINNER_DELAY = 250

interface SearchResultsProps {
  isLoading: boolean
  showNoResults: boolean
  results: RenderedSectionResults[]
  showFixedQuery?: string
}

const Contents: React.FC<SearchResultsProps> = ({
  isLoading,
  showNoResults,
  results,
  showFixedQuery: _unused,
}) => {
  const isEvolved = useEvolvedContext()
  const resultLinksStyle = (heading: string): string =>
    heading === 'Products'
      ? classNames(style.resultsLinks, style.products)
      : style.resultsLinks
  if (isLoading && isEvolved) {
    return (
      <TimedDisplay timing={SPINNER_DELAY}>
        {null}
        <Spinner className={style.Spinner} />
      </TimedDisplay>
    )
  } else if (showNoResults && isEvolved) {
    return (
      <div className={style.noResults}>
        <Icon className={style.alertIcon} type="alert" size="medium" />
        <p>No results found.</p>
        <p>Try a new search to find more results.</p>
      </div>
    )
  } else {
    return (
      <>
        {results.map(({ heading, hits }, index) => (
          <section className={style.category} key={index}>
            <h2 className={style.heading}>{heading}</h2>
            <nav className={resultLinksStyle(heading)}>{hits}</nav>
          </section>
        ))}
      </>
    )
  }
}

const SearchResults: React.FC<SearchResultsProps> = props => (
  <div className={style.results}>
    {props.showFixedQuery !== undefined && (
      <h1 className={style.mainHeading}>
        Results for "{props.showFixedQuery}"
      </h1>
    )}
    <Contents {...props} />
  </div>
)

export default SearchResults
